export default "__VITE_ASSET__DLVfYZma__"